import React, { Component } from 'react';
import { connect } from 'react-redux';
import history from 'pages/router/history';
import qs from 'qs';

import CirrusPager from 'cirrus/Pager';

export const PAGER = {
  PAGE: 'page',
};

class Pager extends Component {
  constructor(props) {
    super(props);

    this.handlePagerClick = this.handlePagerClick.bind(this);
  }

  handlePagerClick(currentPage) {
    let search = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    search[PAGER.PAGE] = { ...search[PAGER.PAGE], number: currentPage };

    search = qs.stringify(search, {
      encode: true,
    });

    history.replace({ pathname: window.location.pathname, search });
  }

  render() {
    const { pagination, style, className } = this.props;

    return (
      <div style={style} className={className}>
        {pagination && (
          <CirrusPager
            {...{
              reversed: true,
              count: pagination.count,
              currentPage: pagination.current_page,
              perPage: pagination.per_page,
              total: pagination.total,
              totalPages: pagination.total_pages,
              onPageChange: this.handlePagerClick,
            }}
          />
        )}
      </div>
    );
  }
}

export default connect()(Pager);
